/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { picklistOptionSchema } from './picklistOptionSchema';

export const fieldSchema = z.object({
  archivedAt: z.iso.datetime().nullish(),
  associatedItemTypeIds: z.array(z.int()).nullish(),
  createdAt: z.iso.datetime(),
  currencyUnit: z.string().nullish(),
  id: z.int(),
  itemTypeAssociationMode: z.enum(['ALL', 'CUSTOM']),
  name: z.string(),
  get picklistOptions() {
    return z.array(picklistOptionSchema).nullish();
  },
  priority: z.string(),
  readonly: z.boolean(),
  type: z.enum([
    'CHECKBOX',
    'CURRENCY',
    'DATE',
    'ITEM',
    'LINK',
    'MULTI_CUSTOMER',
    'MULTI_ITEM',
    'MULTI_LINK',
    'MULTI_PICKLIST',
    'MULTI_TEXT',
    'MULTI_USER',
    'MULTILINE_TEXT',
    'NOTE',
    'NUMERIC',
    'PICKLIST',
    'TEXT',
    'USER',
  ]),
  updatedAt: z.iso.datetime(),
});
